import { useState } from 'react';
import type { CluePublic } from '@cloudfruit-hunts/shared';

interface CoordinateClueProps {
  clue: CluePublic;
}

export function CoordinateClue({ clue }: CoordinateClueProps) {
  const config = clue.interactivityConfig.coordinates;
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [plotted, setPlotted] = useState(false);

  const handlePlot = () => {
    if (latitude && longitude) {
      setPlotted(true);
    }
  };

  return (
    <div className="py-4">
      <p className="text-lg text-text-dark leading-relaxed mb-6">
        {clue.contentText}
      </p>

      {/* Sub-clues */}
      {config?.subClues && (
        <div className="space-y-4 mb-6">
          {config.subClues.map((subClue, index) => (
            <div key={index} className="bg-cream p-4 rounded-lg">
              <p className="text-text-dark">
                <span className="font-semibold text-primary">Part {index + 1}:</span>{' '}
                {subClue.text}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Coordinate Input */}
      <div className="bg-gray-50 p-4 rounded-lg mb-4">
        <h4 className="font-semibold text-text-dark mb-3">Enter Coordinates</h4>
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm text-text-light mb-1">Latitude</label>
            <input
              type="text"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
              placeholder="e.g., 51.4772"
              className="input"
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm text-text-light mb-1">Longitude</label>
            <input
              type="text"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
              placeholder="e.g., 0.0000"
              className="input"
            />
          </div>
          <button onClick={handlePlot} className="btn-secondary">
            Plot
          </button>
        </div>
      </div>

      {/* Map placeholder */}
      <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-lg p-8 text-center">
        {plotted ? (
          <div>
            <p className="text-blue-800 font-semibold mb-2">
              Coordinates: {latitude}, {longitude}
            </p>
            <p className="text-blue-600 text-sm">
              (Interactive map with Leaflet coming in the next phase)
            </p>
          </div>
        ) : (
          <p className="text-blue-600">
            Enter coordinates above and click "Plot" to see the location.
          </p>
        )}
      </div>
    </div>
  );
}
